/* eslint-disable import/no-extraneous-dependencies */
import Qs from 'qs'
import { catchError } from '../../utils/CatchError/CatchError'
import { apiService } from '../_config_/apiservice'

export const getProducts = async (
  cancel: any,
  query: string,
  classificacao: string[],
  page: number
): Promise<GetProductsType | { message: string }> => {
  try {
    const result = await apiService.get('app/produto', {
      cancelToken: cancel.token,
      params: {
        query,
        classificacao,
        page: page - 1,
        size: 7,
      },
      paramsSerializer(paramsAux: any) {
        return Qs.stringify(paramsAux, { arrayFormat: 'repeat' })
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const getProductsResume = async (
  id: string
): Promise<GetProductResumeType | { message: string }> => {
  try {
    const result = await apiService.get(`app/produto/${id}/resumo`, {
      params: {
        id,
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const getClientsDetails = async (
  id: string,
  classificacao: Classification
): Promise<GetDetailsType[] | { message: string }> => {
  try {
    const result = await apiService.get(`app/produto/${id}/clientes`, {
      params: {
        classificacao,
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const getProductAll = async (
  query: string
): Promise<GetProductAll | { message: string }> => {
  try {
    const result = await apiService.get('app/produto/all', {
      params: {
        query,
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

// Opcoes do filtro de Categoria de material (GET app/produto/categorias). Categoria canonica: a do
// ERP quando preenchida, senao o NCM - por isso alguns itens da lista sao codigos NCM, e nao nomes.
export const getCategorias = async (): Promise<
  string[] | { message: string }
> => {
  try {
    const result = await apiService.get('app/produto/categorias')
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}
